import { createFileRoute } from '@tanstack/react-router';
import SharedLinkLandingPage from 'src/SharedLinkPage/SharedLinkLandingPage';

export const Route = createFileRoute('/share/$linkId')({
  component: () => <SharedLinkLandingPage />,
});
